
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/subcategory/[...slug]",
      function () {
        return require("private-next-pages/recipes/subcategory/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/subcategory/[...slug]"])
      });
    }
  